/**
 * Lista canónica de idiomas soportados.
 * Extraída para que supportedLanguages no importe traducciones.
 */
export const LANGUAGE_ROSTER_FROM_ES = [
  'es',
  'en',
  'pt',
  'fr',
  'it',
  'de',
  'nl',
  'pl',
  'ru',
  'el',
  'tr',
  'ar',
  'he',
  'hi',
  'ja',
  'ko',
  'zh',
  'sv',
];
